// extracted by mini-css-extract-plugin
module.exports = {"header":"header--1O0NXzhw","trigger":"trigger--1SsP6ZJb","right":"right--8OkrjO7o","rightIcon":"rightIcon--3QsQOt0K","logo":"logo--HBPTnInc"};